import { z } from 'zod';

import { PAYMENT_PROVIDERS_NAMES, PaymentProviderName } from 'domain/paySettings/helpers';
import { GlobalAccountFormConfig } from './types';

export const globalAccountsConfig: Record<PaymentProviderName, GlobalAccountFormConfig> = {
  [PAYMENT_PROVIDERS_NAMES.airwallex]: {
    fields: [
      {
        type: 'text',
        name: 'name',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.name',
          defaultMessage: 'Name',
        },
        required: true,
        autoFocus: true,
        defaultValue: '',
        editable: true,
      },
      {
        type: 'autocomplete',
        name: 'glBankAccountId',
        optionsKey: 'bankAccounts',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.bankAccount',
          defaultMessage: 'GL Bank Account',
        },
        required: true,
        disableClearable: true,
        defaultValue: '',
        editable: true,
      },
    ],
    dataRequirements: ['bankAccounts'],
    schema: z.object({
      name: z.string().nonempty(),
      glBankAccountId: z.string().nonempty(),
    }),
  },
  [PAYMENT_PROVIDERS_NAMES.checkbook]: {
    fields: [
      {
        type: 'text',
        name: 'name',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.name',
          defaultMessage: 'Name',
        },
        required: true,
        autoFocus: true,
        defaultValue: '',
        editable: true,
      },
      {
        type: 'autocomplete',
        name: 'glBankAccountId',
        optionsKey: 'bankAccounts',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.bankAccount',
          defaultMessage: 'GL Bank Account',
        },
        required: true,
        disableClearable: true,
        defaultValue: '',
        editable: true,
      },
    ],
    dataRequirements: ['bankAccounts'],
    schema: z.object({
      name: z.string().nonempty(),
      glBankAccountId: z.string().nonempty(),
    }),
  },
  [PAYMENT_PROVIDERS_NAMES.openFinance]: {
    fields: [
      {
        type: 'text',
        name: 'name',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.name',
          defaultMessage: 'Name',
        },
        required: true,
        autoFocus: true,
        defaultValue: '',
        editable: true,
      },
      {
        type: 'autocomplete',
        name: 'glBankAccountId',
        optionsKey: 'bankAccounts',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.bankAccount',
          defaultMessage: 'GL Bank Account',
        },
        required: true,
        disableClearable: true,
        defaultValue: '',
        editable: true,
      },
      {
        type: 'text',
        name: 'psuId',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.psuId',
          defaultMessage: 'PSU ID',
        },
        required: true,
        defaultValue: '',
        editable: false,
      },
      {
        type: 'text',
        name: 'accountNumber',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.accountNumber',
          defaultMessage: 'Account number',
        },
        required: true,
        defaultValue: '',
        editable: false,
      },
      {
        type: 'autocomplete',
        name: 'providerId',
        optionsKey: 'payingProviders',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.providerId',
          defaultMessage: 'Bank',
        },
        required: true,
        disableClearable: true,
        defaultValue: '',
        editable: false,
      },
    ],
    dataRequirements: ['bankAccounts', 'payingProviders'],
    schema: z.object({
      name: z.string().nonempty(),
      glBankAccountId: z.string().nonempty(),
      psuId: z.string().nonempty(),
      accountNumber: z
        .string()
        .nonempty()
        .min(
          8,
          'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.accountNumber.validationError',
        )
        .max(
          34,
          'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.accountNumber.validationError',
        ),
      providerId: z.string().nonempty(),
    }),
  },
  [PAYMENT_PROVIDERS_NAMES.leumi]: {
    fields: [],
    schema: z.object({}),
  },
  [PAYMENT_PROVIDERS_NAMES.raiffeisen]: {
    fields: [],
    schema: z.object({}),
  },
  [PAYMENT_PROVIDERS_NAMES.rbs]: {
    fields: [],
    schema: z.object({}),
  },
};
